import { render, staticRenderFns } from "./RolesSettings.vue?vue&type=template&id=8491a97e&scoped=true"
import script from "./RolesSettings.vue?vue&type=script&lang=js"
export * from "./RolesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8491a97e",
  null
  
)

export default component.exports